var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab5"
  }, [!_vm._hideMenu ? _c('Menu', {
    attrs: {
      "active-name": _vm.activeValue
    },
    on: {
      "on-select": _vm.onSelectMenu
    }
  }, [_c('MenuItem', {
    attrs: {
      "name": "PMS"
    }
  }, [_vm._v(` ${$t("1a0ddm5", "PMS系统")} `)]), _c('MenuItem', {
    attrs: {
      "name": "POS"
    }
  }, [_vm._v(` ${$t("1a1nco5", "POS系统")} `)]), _c('MenuItem', {
    attrs: {
      "name": "UC"
    }
  }, [_vm._v(" UC ")])], 1) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('AppDetailReflection', {
    attrs: {
      "treeData": _vm.treeData,
      "retVal": _vm.retVal,
      "leftTitle": _vm._leftTitle,
      "rightTitle": _vm._rightTitle
    },
    on: {
      "on-delete-bind": _vm.onDeleteBind,
      "on-open-modal": _vm.onOpenBind
    }
  })], 1), _c('AppDetailPointModal', {
    ref: "AppDetailPointModal",
    on: {
      "on-submit-bind": _vm.onSubmitBind
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };